module.exports = __webpack_public_path__ + "img/logo_coq.08e5ceb2.png";